import React from 'react';
import { Switch, Route } from 'react-router';
import Home from './containers/Home';
import CompareProject from './containers/CompareProject';
import Error from './containers/Error';
import CostExplorer from './containers/CostExplorer';

const App = () => (
  <Switch>
    <Route exact path="/" component={Home} />
    <Route
      exact
      path="/compare/:projectId/:versionCurrent/:versionOld"
      component={CompareProject}
    />
    <Route exact path="/error" component={Error} />
    <Route exact path="/costexplorer" component={CostExplorer} />
    <Route
      render={() => (
        <Error errorMessage="Page does not exist, Please check the URL" />
      )}
    />
  </Switch>
);

export default App;



// WEBPACK FOOTER //
// ./src/App.js